import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, take } from 'rxjs';
import { Product } from 'src/app/models/state/pre-application.model';
import { selectCurrentProcessInfo } from 'src/app/state/selectors/onboarding-process.selectors';
import { selectProductInfo } from 'src/app/state/selectors/pre-application.selectors';

// Número fijo de pasos para que la barra avance de 5 en 5
const TOTAL_STEPS_DISPLAY = 20;

@Component({
	selector: 'cmv-step-process',
	templateUrl: './step-process.component.html',
	styleUrls: ['./step-process.component.scss'],
})
export class StepProcessComponent {
	totalSteps: number = TOTAL_STEPS_DISPLAY;
	currentStep: number = 1;
	currentPercentage: number = 5;
	steps: Array<boolean> = [];
	@Input() darkMode: boolean = false;

	productInfo$: Observable<Product> = this.store.select(selectProductInfo);

	constructor(private store: Store) {
		this.store
			.select(selectCurrentProcessInfo)
			.pipe(take(1))
			.subscribe({
				next: currentProcessInfo => {
					// Usar mínimo TOTAL_STEPS_DISPLAY para que la barra vaya de 5 en 5
					this.totalSteps = Math.max(
						currentProcessInfo.totalSteps || 0,
						TOTAL_STEPS_DISPLAY
					);
					this.currentStep = currentProcessInfo.currentStepNumber;
					this.steps = Array.from(
						{ length: this.totalSteps },
						(_x, i) => i + 1 <= this.currentStep
					);
					const raw = Math.round(
						((this.currentStep - 1) / this.totalSteps) * 100
					);
					this.currentPercentage = Math.max(5, raw);
				},
			});
	}

	get progress(): number {
		if (!this.totalSteps) return 5;
		const raw = Math.round(((this.currentStep - 1) * 100) / this.totalSteps);
		return Math.max(5, raw);
	}
}
